import { useMemo } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useAuth } from "../provider/auth_provider";
import Profile from "../components/profile";
import UserAgreement from "../components/UserAgreement";
import LandingFallback from "./landingFallback";
import Support from "../components/support";
// import { clientName } from "../config";
import theme from "../theme";
// import CompetetiveAnalysisImage from "./../assets/landing/competitor-analysis.svg";
import ProductAnalysisImage from "./../assets/landing/product-analysis.svg";
import DocumentAnalyzerImage from "./../assets/landing/document-analyzer.svg";
import SelfHelp from "./../assets/landing/self-help.svg";
import HRPoliciesImage from "./../assets/landing/hr-policies.svg";
import legalImage from "../assets/landing/legal-chat.svg";
import qcImage from "../assets/landing/qc.svg";
import policyImage from "../assets/landing/policy-info.svg";
// import ctrlNLogo from "./../assets/teamlogo.svg";
import logo from "../assets/HDFC-Ergo-logo.png";

type CardItemProps = {
  image: string;
  title: string;
  description: string;
  link: string;
  buttonText: string;
  show: boolean;
};

const CardItem = ({
  image,
  title,
  description,
  link,
  buttonText,
  show,
}: CardItemProps) => {
  if (!show) return null;
  return (
    <Grid item sx={{ width: "500px" }}>
      <Card
        elevation={8}
        sx={{
          borderRadius: "1.5rem",
          // maxWidth: "fit-content",
          maxHeight: "150px",
          bgcolor: "transparent",
        }}
      >
        <Chip
          variant="filled"
          label="beta"
          size="small"
          sx={{
            m: "5px",
            float: "right",
            cursor: "default",
            fontSize: "10px",
            color: "white",
            fontWeight: "800",
            background: "linear-gradient(90deg, #a29bfe, #ff7675)",
          }}
        />
        <CardContent
          sx={{
            padding: ".5rem",
            paddingRight: 0,
            paddingBottom: 0,
            display: "flex",
            // flexDirection: "row-reverse",
          }}
        >
          {/* <div
            style={{
              display: "flex",
              justifyItems: "center",
              alignItems: "center",
              width: "50%",
              margin: 0,
            }}
          > */}
          <img
            src={image}
            alt={title}
            height={image === HRPoliciesImage ? "110" : "125"}
            style={{ width: "25%", margin: 0 }}
          />
          {/* </div> */}
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              gap: 2,
            }}
          >
            <Typography
              variant="body2"
              color="#0E0E0E"
              fontWeight={400}
              textAlign="center"
              fontSize={12}
            >
              {description}
            </Typography>
            <CardActions
              sx={{
                // padding: "0.5rem 1rem 1rem 1rem",
                display: "flex",
                justifyContent: "space-around",
                width: "100%",
                padding: 0,
              }}
            >
              <Typography
                gutterBottom
                variant="h6"
                component="div"
                fontWeight={700}
                fontSize={14}
                textAlign="center"
              >
                {title}
              </Typography>
              <Link to={link}>
                <Button
                  sx={{
                    color: "#171515",
                    borderRadius: "3.75rem",
                    border: "0.125rem solid #171515",
                    fontSize: "0.8rem",
                    padding: "0.25rem 1.5rem",
                    "&:hover": {
                      color: "white",
                      backgroundColor: "#171515",
                    },
                  }}
                >
                  {buttonText}
                </Button>
              </Link>
            </CardActions>
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default function Landing() {
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const {
    userDetails: { scopes },
  } = useAuth();

  const cardData = useMemo(() => {
    return [
      {
        image: HRPoliciesImage,
        title: "Chat @ People",
        description:
          "All you need to know about HR Policies, Procedures and much more",
        link: "/people",
        buttonText: "Let's Chat",
        show: scopes?.includes("people"),
      },

      // {
      //   image: CompetetiveAnalysisImage,
      //   title: "Chat @ Company",
      //   description: "All you need to know about Competitor Analysis",
      //   link: "/company",
      //   buttonText: "Let's Chat",
      //   show: scopes?.includes("company"),
      // },
      {
        image: ProductAnalysisImage,
        title: "Chat @ Product",
        description: "All you need to know about Product Catalogue",
        link: "/product",
        buttonText: "Let's Chat",
        show: scopes?.includes("product"),
      },
      {
        image: DocumentAnalyzerImage,
        title: "Chat @ Document",
        description: "All you need to know about Document Analyzer",
        link: "/document",
        buttonText: "Let's Chat",
        show: scopes?.includes("document"),
      },
      {
        image: SelfHelp,
        title: "Chat @ Help",
        description: "All you need to know about FAQ's",
        link: "/help",
        buttonText: "Let's Chat",
        show: scopes?.includes("help"),
      },
      {
        image: legalImage,
        title: "Chat @ Legal AI - Petition",
        description: "All you need to know about Legal Petition",
        link: "/legal",
        buttonText: "Let's Chat",
        show: scopes?.includes("legal"),
      },
      {
        image: qcImage,
        title: "Chat @ QC",
        description: "All you need to know about Quote Computation",
        link: "/qc",
        buttonText: "Let's Chat",
        show: scopes?.includes("qc"),
      },
      {
        image: DocumentAnalyzerImage,
        title: "Document Scan AI",
        description: "All you need to know about AI-Powered Document Scanning",
        link: "/scan-document",
        buttonText: "Explore",
        show: scopes?.includes("document"),
      },
      {
        image: policyImage,
        title: "Chat @ KYP",
        description: "All you need to know about Your Policy",
        link: "/kyp",
        buttonText: "Let's Chat",
        show: scopes?.includes("kyp"),
      },
      {
        image: DocumentAnalyzerImage,
        title: "WC Claims",
        description: "All you need to know about WC Claims Card",
        link: "/wc-claims",
        buttonText: "Explore",
        show: scopes?.includes("wc-claims"),
      },
    ];
  }, [scopes]);

  return (
    <div
      style={{
        background:
          "linear-gradient(90deg, #ff817f 0%, #fed0b2 20%, #ffffff 60%)",
      }}
    >
      <UserAgreement />

      <Box
        bgcolor={"hsla(215, 15%, 97%, 0.5)"}
        height={"100svh"}
        px={2}
        pt={2}
        overflow="auto"
      >
        <Box display="flex" alignContent="flex-end" justifyContent="flex-end">
          <Profile />
        </Box>
        {!scopes || !scopes?.length ? (
          <LandingFallback />
        ) : (
          <Box sx={{ position: "relative" }}>
            {/* Logo and Title Section */}
            <Box sx={{ pt: "0 !important" }}>
              <Box
                display={"flex"}
                justifyContent="center"
                alignItems={"center"}
                mb={1}
                gap={2}
                sx={{
                  position: "absolute",
                  left: "1%",
                  top: "-5%",
                }}
              >
                <img
                  src={logo}
                  alt="HDFC Ergo Logo"
                  style={{
                    width: isSmallScreen ? "3.75rem" : "5rem",
                    height: "auto",
                  }}
                />
              </Box>
              <Typography
                sx={{
                  textAlign: "center",
                  // background:
                  //   "linear-gradient(1deg, #ff817f, #fed0b2, #feebd7)",
                  background:
                    "linear-gradient(1deg, rgb(232, 80, 91), rgb(255 191 149), rgb(255 253 252))",
                  WebkitBackgroundClip: "text !important",
                  WebkitTextFillColor: "transparent !important",
                  fontWeight: 700,
                  fontSize: "3.75rem",
                  marginBottom: 0,
                  transition: "all 0.3s ease-in-out",
                  letterSpacing: "-2px",
                  marginTop: "-5px",
                }}
              >
                FUSION
              </Typography>
              <Typography
                variant="body1"
                align="center"
                fontSize={13}
                color={"#0E0E0E"}
                textAlign={"center"}
              >
                A secure internal platform with powerful AI assistants for smart{" "}
                <br />
                answers & more-all through natural, human-like conversations.
              </Typography>
              {/* <Typography
                variant="body1"
                align="center"
                mb={3}
                fontSize={13}
                color={"#4d4848"}
              >
                Get answers through human like conversations, generate quality
                content and more.
              </Typography> */}
            </Box>
            <Typography
              sx={{
                fontWeight: 700,
                textDecoration: "underline",
                textUnderlineOffset: "6px",
                textAlign: "center",
                marginTop: "10px",
                marginBottom: "20px",
              }}
            >
              {" "}
              Chat with our AI Assistant
            </Typography>
            <Grid
              container
              spacing={2}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Grid item md={12}>
                <Grid container spacing={2} justifyContent={"center"}>
                  {/* Cards Section */}
                  {cardData.map((card) => (
                    <CardItem key={card.title} {...card} />
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        )}

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            width: "100%",
            // position: isSmallScreen ? "static" : "fixed",
            bottom: "0.125rem",
            pt: isSmallScreen ? 4 : 4,
            pb: 1,
          }}
        >
          {/* <Box display={"flex"} alignItems={"center"}>
            <Typography fontWeight={500} mr={0.6} fontSize={13}>
              Powered by
            </Typography>
            <img src={ctrlNLogo} alt="ctrl n" height={40} />
          </Box> */}
          {scopes?.length > 0 && <Support />}
        </Box>
      </Box>
    </div>
  );
}
